import MaterialButton from "@mui/material/Button";

const Button = ({
  className,
  label,
  labelClass,
  type,
  outlined,
  disabled,
  onClick,
  fullWidth,
  color,
  sx,
  white,
  danger,
  ...rest
}) => {
  return (
    <MaterialButton
      {...rest}
      sx={{
        ...sx,
        ...((white || danger) && {
          color: white ? "#ffffff" : "#d32f2f",
          borderColor: white ? "#ffffff" : "#d32f2f",
        }),
        "&:hover": {
          opacity: 0.7,
          ...((white || danger) && {
            borderColor: white ? "#ffffff" : "#d32f2f",
          }),
          ...(sx?.["&:hover"] || {}),
        },
      }}
      className={`${className}`}
      fullWidth={fullWidth}
      variant={outlined ? "outlined" : "contained"}
      type={type}
      disabled={disabled}
      onClick={onClick}
      color={color}>
      <span className={labelClass}>{label}</span>
    </MaterialButton>
  );
};

export default Button;
